import { Module } from "vuex";
import { RootState, RecipesState } from "@/types/recipes";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: RecipesState = {
  detailInfo: null,
  folderList: null,
  addRecipeResult: null,
  deleteRecipeResult: null,
  recentMyList: null
};

export const recipes: Module<RecipesState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
